import { render, staticRenderFns } from "./Kabupaten.vue?vue&type=template&id=4559fc2a"
import script from "./Kabupaten.vue?vue&type=script&lang=js"
export * from "./Kabupaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports